(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3229],{

/***/ 23652:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/privacidad",
      function () {
        return __webpack_require__(77069);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Lead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/components/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(19296);
;// CONCATENATED MODULE: ./src/components/Lead/Lead.js




var defaultProps = {
    muted: true,
    className: null
};
var propTypes = {
    muted: (prop_types_default()).bool,
    className: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
function Lead(param) {
    var muted = param.muted, className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        className: (0,clsx_m/* default */.Z)("text-lg font-normal leading-normal lg:text-xl", muted && "text-gray-600", className),
        children: children
    });
};
Lead.defaultProps = defaultProps;
Lead.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Lead/index.js

/* harmony default export */ var components_Lead = (Lead);


/***/ }),

/***/ 19296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Paragraph/Paragraph.js





var defaultProps = {
    className: "",
    children: null
};
var propTypes = {
    className: (prop_types_default()).string,
    children: (prop_types_default()).node
};
function Paragraph(_param) {
    var className = _param.className, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, otherProps), {
        children: children
    }));
};
Paragraph.defaultProps = defaultProps;
Paragraph.propTypes = propTypes;

;// CONCATENATED MODULE: ./src/components/Paragraph/index.js

/* harmony default export */ var components_Paragraph = (Paragraph);


/***/ }),

/***/ 86402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LegalLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _components_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30341);
/* harmony import */ var _components_Lead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59679);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48300);
/* harmony import */ var _BasicLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8546);








function LegalNavigationLink(param) {
    var href = param.href, isActive = param.isActive, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        href: href,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("inline-flex py-2", isActive === true && "pointer-events-none font-medium text-gray-900", isActive === false && "text-gray-500 hover:text-gray-900 transition ease-in-out duration-300"),
        children: children
    });
}
var defaultProps = {};
var propTypes = {
    pageTitle: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().node.isRequired)
};
function LegalLayout(param) {
    var pageTitle = param.pageTitle, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BasicLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-gradient-to-tl from-green-100 to-green-50 py-10 lg:py-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center text-center space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-xl lg:text-5xl font-semibold tracking-tight",
                                children: "Pol\xedticas y procedimientos"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                maxWidth: "max-w-screen-lg",
                                className: "lg:px-24",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Lead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    children: "Nos comprometemos a mantener la seguridad de sus datos, la privacidad de su informaci\xf3n privada y a ser transparentes sobre nuestras pr\xe1cticas como empresa."
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "py-10 lg:pb-20 bg-gradient-to-t from-gray-100 to-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "lg:col-span-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative lg:sticky lg:top-32 z-10",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                                        className: "flex flex-col space-y-1 text-lg lg:py-10",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/tos",
                                                isActive: router.pathname === "/legal/tos",
                                                children: "T\xe9rminos de servicio"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/privacidad",
                                                isActive: router.pathname === "/legal/privacidad",
                                                children: "Pol\xedtica de privacidad"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LegalNavigationLink, {
                                                href: "/legal/cookies",
                                                isActive: router.pathname === "/legal/cookies",
                                                children: "Pol\xedtica de cookies"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "lg:col-span-9 pt-10 divide-y",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-xl lg:text-4xl font-semibold tracking-tight pb-10",
                                        children: pageTitle
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "prose lg:prose-lg font-normal",
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
LegalLayout.defaultProps = defaultProps;
LegalLayout.propTypes = propTypes;


/***/ }),

/***/ 77069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Privacy; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_LegalLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86402);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48300);



function Privacy() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "font-normal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "\xbfQu\xe9 hacemos con tu informaci\xf3n?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Cuando compras algo de nuestro sitio, como parte del proceso de compra venta, nosotros recolectamos la informaci\xf3n personal que nos das tales como nombre, direcci\xf3n y correo electr\xf3nico."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Cuando navegas en nuestro sitio, tambi\xe9n recibimos de manera autom\xe1tica la direcci\xf3n de protocolo de internet de tu computadora (IP) con el fin de proporcionarnos informaci\xf3n que nos ayuda a conocer acerca de su navegador y sistema operativo."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Email marketing: Con tu permiso, podremos enviarte correos electr\xf3nicos acerca de nuestro sitio, nuevos productos y otras actualizaciones."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Consentimiento"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "\xbfC\xf3mo obtienen mi consentimiento?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Cuando nos provees tu informaci\xf3n personal para completar una transacci\xf3n, verificar tu tarjeta de cr\xe9dito, crear una orden, implicamos que aceptas la recolecci\xf3n y uso por esa raz\xf3n espec\xedfica solamente."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Si te pedimos tu informaci\xf3n personal por una raz\xf3n secundaria, como marketing, te pediremos directamente tu expreso consentimiento, o te daremos la oportunidad de negarte."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "\xbfC\xf3mo puedo anular mi consentimiento?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    "Si luego de haber aceptado cambias de opini\xf3n, puedes anular tu consentimiento para que te contactemos, por la recolecci\xf3n, uso o divulgaci\xf3n de tu informaci\xf3n, en cualquier momento, contact\xe1ndonos a\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "mailto:info@aibes.org",
                        children: "info@aibes.org"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Divulgaci\xf3n"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    "Podemos divulgar tu informaci\xf3n personal si se nos requiere por ley o si violas nuestros\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: "/legal/tos",
                        children: "T\xe9rminos de servicio"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Servicios de terceras partes"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "En general, los proveedores de terceras partes utilizados por nosotros solo recopilar\xe1n, usar\xe1n y divulgar\xe1n tu informaci\xf3n en la medida que sea necesaria para que les permita desempe\xf1ar los servicios que nos proveen."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Sin embargo, algunos proveedores de servicios de terceros, tales como pasarelas de pago y otros procesadores de transacciones de pago, tienen sus propias pol\xedticas de privacidad con respecto a la informaci\xf3n que estamos obligados a proporcionarles para las transacciones relacionadas con las compras."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Para estos proveedores, te recomendamos que leas las pol\xedticas de privacidad para que puedas entender la manera en que tu informaci\xf3n personal ser\xe1 manejada."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "En particular, recuerda que algunos proveedores pueden estar ubicados o contar con instalaciones que se encuentran en una jurisdicci\xf3n diferente a ti o nosotros.\xa0 As\xed que si deseas proceder con una transacci\xf3n que involucra los servicios de un proveedor a terceros, tu informaci\xf3n puede estar sujeta a las leyes de la jurisdicci\xf3n (jurisdicciones) en que se encuentra el proveedor de servicios o sus instalaciones."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "A modo de ejemplo, si te encuentras en Canad\xe1 y tu transacci\xf3n es procesada por una pasarela de pago con sede en Estados Unidos, entonces tu informaci\xf3n personal utilizada para completar la transacci\xf3n puede ser sujeto de divulgaci\xf3n en virtud de la legislaci\xf3n de Estados Unidos, incluyendo la Ley Patriota."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Una vez que abandonas el sitio web de nuestro sitio o te rediriges a un sitio o aplicaci\xf3n de terceros, ya no est\xe1s siendo regulados por la presente Pol\xedtica de privacidad o los T\xe9rminos de Servicio de nuestra p\xe1gina web."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "Enlaces"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Cuando haces clic en enlaces de nuestro sitio, puede que seas redirigido fuera de nuestro sitio. No somos responsables por las pr\xe1cticas de privacidad de otros sitios y te recomendamos leer sus normas de privacidad."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Seguridad"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Para proteger tu informaci\xf3n personal, tomamos precauciones razonables y seguimos las mejores pr\xe1cticas de la industria para asegurarnos de que no haya p\xe9rdida de manera inapropiada, mal uso, acceso, divulgaci\xf3n, alteraci\xf3n o destrucci\xf3n de la misma."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Si nos proporcionas la informaci\xf3n de tu tarjeta de cr\xe9dito, dicha informaci\xf3n es encriptada mediante la tecnolog\xeda Secure Socket Layer (SSL) y se almacena con un cifrado AES-256. Aunque ning\xfan m\xe9todo de transmisi\xf3n a trav\xe9s de Internet o de almacenamiento electr\xf3nico es 100% seguro, seguimos todos los requisitos de PCI-DSS e implementamos normas adicionales aceptadas por la industria."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: "Cookies"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Nosotros y nuestros socios utilizamos cookies para operar y administrar nuestro sitio, facilitarle el uso del sitio durante futuras visitas y recopilar datos de uso en nuestro sitio."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    "Para obtener m\xe1s informaci\xf3n sobre las cookies que se utilizan en nuestro sitio, consulte nuestra\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: "/legal/cookies",
                        children: "Pol\xedtica de cookies"
                    }),
                    ", que forma parte de esta Pol\xedtica de privacidad."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Edad de consentimiento"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Al utilizar este sitio, declaras que tienes al menos la mayor\xeda de edad en tu estado o provincia de residencia, o que tienes la mayor\xeda de edad en tu estado o provincia de residencia y que nos has dado tu consentimiento para permitir que cualquiera de tus dependientes menores use este sitio."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Cambios a esta Pol\xedtica de privacidad"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Nos reservamos el derecho de modificar esta pol\xedtica de privacidad en cualquier momento, as\xed que por favor rev\xedsala frecuentemente. Cambios y aclaraciones entrar\xe1n en vigencia inmediatamente despu\xe9s de su publicaci\xf3n en el sitio web. Si hacemos cambios materiales a esta pol\xedtica, notificaremos aqu\xed que ha sido actualizada, por lo que cual est\xe1s enterado de qu\xe9 informaci\xf3n recopilamos, c\xf3mo y bajo qu\xe9 circunstancias, si las hubiere, la utilizamos y/o divulgamos."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "Si nuestro sitio es adquirido o fusionado con otra empresa, tu informaci\xf3n puede ser transferida a los nuevos propietarios, para que podamos seguir en comunicaci\xf3n."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Preguntas e informaci\xf3n de contacto"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                children: [
                    "Si quieres acceder, corregir, enmendar o borrar cualquier informaci\xf3n personal que poseamos sobre ti, registrar una queja, o simplemente quieres m\xe1s informaci\xf3n contacta a nuestro Oficial de Cumplimiento de privacidad\xa0",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "mailto:malena.pereda@aibes.org",
                        children: "malena.pereda@aibes.org"
                    }),
                    "."
                ]
            })
        ]
    });
};
Privacy.layoutProps = {
    Layout: _layouts_LegalLayout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    pageTitle: "Pol\xedtica de privacidad"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(23652); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);